import { render, staticRenderFns } from "./AppInfoHandler.vue?vue&type=template&id=5c3a9859&scoped=true&"
import script from "./AppInfoHandler.vue?vue&type=script&lang=js&"
export * from "./AppInfoHandler.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoHandler.vue?vue&type=style&index=0&id=5c3a9859&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a9859",
  null
  
)

export default component.exports